import React from "react";
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCheckCircle} from "@fortawesome/pro-solid-svg-icons";
import Colors from "../../../styles/colors";
import {makeStyles} from "@material-ui/core/styles";
import Layout from "./Layout";

interface IPieProgress {
    percentage: number
}

function PieProgress(p: IPieProgress){
    const pieProgressStyle = makeStyles({
        root: {
            width: Layout.accordionWidth,
            height: "100%",
            background: Colors.white,
            borderRadius: 2,
            boxShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.2), 0 -1px 3px -1px rgba(0, 0, 0, 0.1);",
            marginBottom: 16,
            overflow: "visible",
        },
        headerIcon: {
            marginLeft: 16,
            fontSize: 32,
            color: Colors.primary,
            marginRight: 12,
        },
        circularProgress:{
            width: 32,
            height: 32,
            position: "relative",
            marginLeft: 16,
            marginRight: 12,
        },
    });

    const style = pieProgressStyle()
    return(
        (p.percentage >= 100) ?
            <FontAwesomeIcon icon={faCheckCircle} className={style.headerIcon}/> :
            <div className={style.circularProgress}>
                <CircularProgressbar
                    value={p.percentage}
                    strokeWidth={50}
                    styles={buildStyles({
                        strokeLinecap: "butt",
                        trailColor: `${Colors.grey}`,
                        pathColor: `${Colors.primary}`,
                    })}
                />
            </div>
    )
}
export default PieProgress